// jsPDF será importado dinamicamente

class PdfExportService {
  constructor() {
    this.logoUrl = 'https://abaas.com.br/wp-content/uploads/2023/09/stok-logo.png';
  }

   async exportOrdersReport(orders, filters = {}) {
     try {
       const { jsPDF } = await import('jspdf');
       const pdf = new jsPDF('l', 'mm', 'a4');
       const startY = await this.addHeader(
         pdf,
         'Relatório de Ordens de Serviço',
         'Zaffari'
       );
 
       const { margin } = this.getLayout(pdf);
       let currentY = startY + 10;
 
       const applied = [];
       if (filters.status) applied.push(`Status: ${String(filters.status)}`);
       if (filters.tecnico) applied.push(`Técnico: ${String(filters.tecnico)}`);
       if (filters.dataInicio) {
         const d = new Date(filters.dataInicio);
         applied.push(`Data início: ${d.toLocaleDateString('pt-BR')}`);
       }
       if (filters.dataFim) {
         const d = new Date(filters.dataFim);
         applied.push(`Data fim: ${d.toLocaleDateString('pt-BR')}`);
       }
 
       if (applied.length > 0) {
         pdf.setFontSize(11);
         pdf.setFont('helvetica', 'bold');
         pdf.setTextColor(51, 65, 85);
         pdf.text('Filtros aplicados', margin.left, currentY);
         currentY += 7;
 
         pdf.setFontSize(9);
         pdf.setFont('helvetica', 'normal');
         pdf.setTextColor(100, 116, 139);
         applied.forEach((line) => {
           pdf.text(String(line), margin.left + 6, currentY);
           currentY += 5;
         });
 
         currentY += 5;
       }
 
       const concluidas = (orders || []).filter((o) =>
         String(o.status || '').includes('Concluída')
       ).length;
       const kpis = [
         { title: 'Total de Ordens', value: (orders || []).length || '0' },
         { title: 'Ordens Concluídas', value: concluidas || '0' }
       ];
       currentY = this.addKPIs(pdf, kpis, currentY);
 
       const columns = [
         { key: 'id', label: 'Número' },
         { key: 'cliente', label: 'Cliente' },
         { key: 'status', label: 'Status' },
         { key: 'tecnico', label: 'Técnico' },
         { key: 'data', label: 'Data' }
       ];
       this.addTable(pdf, orders || [], columns, 'Lista de Ordens', currentY);
 
       pdf.save(`ordens_servico_${new Date().toISOString().split('T')[0]}.pdf`);
     } catch (error) {
       console.error('Erro ao gerar PDF de Ordens:', error);
       throw error;
     }
   }
 
  // Medidas padrão para A4 horizontal e margens
  getLayout(pdf) {
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = { top: 20, right: 20, bottom: 20, left: 20 };
    const contentWidth = pageWidth - margin.left - margin.right;
    const contentHeight = pageHeight - margin.top - margin.bottom;
    return { pageWidth, pageHeight, margin, contentWidth, contentHeight };
  }

  // Carregar a logo como imagem
  async loadLogo() {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = this.logoUrl;
    });
  }

  // Adicionar cabeçalho com logo
  async addHeader(pdf, title, subtitle = '') {
    try {
      const logo = await this.loadLogo();
      const { margin, contentWidth } = this.getLayout(pdf);

      // Logo
      const logoWidth = 45;
      const logoHeight = (logo.height * logoWidth) / logo.width;
      const logoX = margin.left;
      const logoY = margin.top;
      pdf.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);

      // Textos
      const textX = logoX + logoWidth + 10;
      let textY = margin.top + 15;
      pdf.setFontSize(22);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(51, 65, 85);
      pdf.text(String(title), textX, textY);

      if (subtitle) {
        pdf.setFontSize(13);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(100, 116, 139);
        textY += 12;
        pdf.text(String(subtitle), textX, textY);
      }

      const currentDate = new Date().toLocaleDateString('pt-BR');
      pdf.setFontSize(11);
      pdf.setTextColor(100, 116, 139);
      textY += 12;
      pdf.text(`Gerado em: ${currentDate}`, textX, textY);

      // Separador
      const separatorY = Math.max(logoY + logoHeight + 8, textY + 8);
      pdf.setDrawColor(226, 232, 240);
      pdf.line(margin.left, separatorY, margin.left + contentWidth, separatorY);

      return separatorY;
    } catch (error) {
      console.error('Erro ao carregar logo:', error);
      const { margin, contentWidth } = this.getLayout(pdf);
      let textY = margin.top + 10;
      pdf.setFontSize(22);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(51, 65, 85);
      pdf.text(String(title), margin.left, textY);
      if (subtitle) {
        pdf.setFontSize(13);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(100, 116, 139);
        textY += 12;
        pdf.text(String(subtitle), margin.left, textY);
      }
      const currentDate = new Date().toLocaleDateString('pt-BR');
      pdf.setFontSize(11);
      pdf.setTextColor(100, 116, 139);
      textY += 12;
      pdf.text(`Gerado em: ${currentDate}`, margin.left, textY);
      const separatorY = textY + 8;
      pdf.setDrawColor(226, 232, 240);
      pdf.line(margin.left, separatorY, margin.left + contentWidth, separatorY);
      return separatorY;
    }
  }

  // Adicionar KPIs
  addKPIs(pdf, kpis, startY) {
    const { margin, contentWidth } = this.getLayout(pdf);
    let currentY = startY + 28;

    pdf.setFontSize(18);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(51, 65, 85);
    pdf.text('Indicadores Principais', margin.left, currentY);
    currentY += 18;

    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');

    const itemsPerRow = 4;
    const gap = 8;
    const itemWidth = (contentWidth - gap * (itemsPerRow - 1)) / itemsPerRow;
    const itemHeight = 26;

    kpis.forEach((kpi, index) => {
      const row = Math.floor(index / itemsPerRow);
      const col = index % itemsPerRow;
      const x = margin.left + col * (itemWidth + gap);
      const y = currentY + row * (itemHeight + 2);

      pdf.setDrawColor(226, 232, 240);
      pdf.setFillColor(248, 250, 252);
      pdf.roundedRect(x, y - 14, itemWidth, itemHeight, 3, 3, 'FD');

      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(51, 65, 85);
      pdf.text(String(kpi.title), x + 5, y - 4);

      pdf.setFontSize(12);
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(59, 130, 246);
      pdf.text(String(kpi.value), x + 5, y + 6);
    });

    const rows = Math.ceil(kpis.length / itemsPerRow);
    return currentY + rows * (itemHeight + 2) + 8;
  }

  // Adicionar tabela
  addTable(pdf, data, columns, title, startY) {
    const { margin, contentWidth, pageHeight } = this.getLayout(pdf);
    let currentY = startY + 12;

    // Título da tabela
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(51, 65, 85);
    pdf.text(String(title), margin.left, currentY);
    currentY += 8;

    // Cabeçalho
    pdf.setFontSize(9);
    pdf.setFont('helvetica', 'bold');
    pdf.setFillColor(248, 250, 252);
    pdf.setDrawColor(226, 232, 240);
    const colWidth = contentWidth / columns.length;
    let x = margin.left;
    columns.forEach((column) => {
      pdf.rect(x, currentY - 5, colWidth, 8, 'FD');
      pdf.setTextColor(51, 65, 85);
      pdf.text(String(column.label), x + 2, currentY);
      x += colWidth;
    });
    currentY += 8;

    // Linhas
    pdf.setFontSize(8);
    pdf.setFont('helvetica', 'normal');
    const rowHeight = 6;
    data.slice(0, 30).forEach((row) => {
      if (currentY > pageHeight - margin.bottom - rowHeight) {
        pdf.addPage();
        currentY = margin.top;
        // Reescreve cabeçalho na nova página
        x = margin.left;
        pdf.setFontSize(9);
        pdf.setFont('helvetica', 'bold');
        pdf.setFillColor(248, 250, 252);
        pdf.setDrawColor(226, 232, 240);
        columns.forEach((column) => {
          pdf.rect(x, currentY - 5, colWidth, 8, 'FD');
          pdf.setTextColor(51, 65, 85);
          pdf.text(String(column.label), x + 2, currentY);
          x += colWidth;
        });
        currentY += 8;
        pdf.setFontSize(8);
        pdf.setFont('helvetica', 'normal');
      }

      x = margin.left;
      columns.forEach((column) => {
        const value = row[column.key] ?? '';
        const str = String(value);
        const displayValue = str.length > 40 ? str.substring(0, 37) + '...' : str;
        pdf.setTextColor(51, 65, 85);
        pdf.text(displayValue, x + 2, currentY);
        x += colWidth;
      });
      currentY += rowHeight;
    });

    return currentY + 6;
  }

  // Adicionar gráfico (simulado como texto)
  addChart(pdf, chartData, title, startY) {
    const { margin, pageHeight, contentWidth } = this.getLayout(pdf);
    let currentY = startY + 15;

    // Título do gráfico
    pdf.setFontSize(16);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(51, 65, 85);
    pdf.text(String(title), margin.left, currentY);
    currentY += 15;

    if (!chartData || chartData.length === 0) {
      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(100, 116, 139);
      pdf.text('Nenhum dado disponível para exibição', margin.left, currentY);
      return currentY + 15;
    }

    // Encontrar o valor máximo para normalizar as barras
    const maxValue = Math.max(...chartData.map(item => item.value));
    const maxBarWidth = contentWidth * 0.6; // 60% da largura para as barras
    const labelWidth = contentWidth * 0.35; // 35% para os labels
    
    pdf.setFontSize(9);
    pdf.setFont('helvetica', 'normal');

    chartData.slice(0, 12).forEach((item, index) => {
      if (currentY > pageHeight - margin.bottom - 15) {
        pdf.addPage();
        currentY = margin.top + 20;
        // Reescrever título na nova página
        pdf.setFontSize(16);
        pdf.setFont('helvetica', 'bold');
        pdf.setTextColor(51, 65, 85);
        pdf.text(String(title) + ' (continuação)', margin.left, currentY);
        currentY += 15;
        pdf.setFontSize(9);
        pdf.setFont('helvetica', 'normal');
      }

      // Label do item
      pdf.setTextColor(51, 65, 85);
      const labelText = String(item.label).length > 45 ? 
        String(item.label).substring(0, 42) + '...' : 
        String(item.label);
      pdf.text(labelText, margin.left, currentY);

      // Barra visual
      const barWidth = maxValue > 0 ? (item.value / maxValue) * maxBarWidth : 0;
      const barX = margin.left + labelWidth;
      const barY = currentY - 4;
      const barHeight = 6;

      // Cor da barra baseada no índice
      const colors = [
        [59, 130, 246],   // Azul
        [16, 185, 129],   // Verde
        [245, 158, 11],   // Amarelo
        [239, 68, 68],    // Vermelho
        [139, 92, 246],   // Roxo
        [236, 72, 153],   // Rosa
        [20, 184, 166],   // Teal
        [251, 146, 60],   // Laranja
      ];
      const color = colors[index % colors.length];
      
      // Desenhar barra de fundo (cinza claro)
      pdf.setFillColor(226, 232, 240);
      pdf.rect(barX, barY, maxBarWidth, barHeight, 'F');
      
      // Desenhar barra de valor (colorida)
      if (barWidth > 0) {
        pdf.setFillColor(color[0], color[1], color[2]);
        pdf.rect(barX, barY, barWidth, barHeight, 'F');
      }

      // Valor numérico
      pdf.setTextColor(51, 65, 85);
      pdf.setFont('helvetica', 'bold');
      pdf.text(String(item.value), barX + maxBarWidth + 5, currentY);
      pdf.setFont('helvetica', 'normal');

      currentY += 12;
    });

    // Adicionar total se houver mais itens
    if (chartData.length > 12) {
      pdf.setFontSize(8);
      pdf.setTextColor(100, 116, 139);
      pdf.text(`... e mais ${chartData.length - 12} itens`, margin.left, currentY);
      currentY += 8;
    }

    return currentY + 10;
  }


    // Exportar relatório do Dashboard
  async exportDashboardReport(data, options = {}) {
     console.log('Iniciando exportação do Dashboard PDF...', data);
     
     try {
       // Importação dinâmica
       const { jsPDF } = await import('jspdf');
       const pdf = new jsPDF('l', 'mm', 'a4');
      
      // Cabeçalho
      const startY = await this.addHeader(pdf, 'Dashboard Zaffari', 'Relatório Geral de Ordens de Serviço');
    
    // KPIs
    const kpis = [
      { title: 'Total de Ordens', value: data.totalOrders || '0' },
      { title: 'Ordens Zaffari', value: data.zaffariOrders || '0' },
      { title: 'Ordens Pendentes', value: data.pendingOrders || '0' },
      { title: 'Ordens Concluídas', value: data.completedOrders || '0' }
    ];
    
    let currentY = this.addKPIs(pdf, kpis, startY);
     
    const includeCharts = options.includeCharts ?? false;
    const includeList = options.includeList ?? true;

    if (includeCharts) {
      if (data.statusData && data.statusData.length > 0) {
        currentY = this.addChart(pdf, data.statusData, 'Distribuição por Status', currentY);
      }
      if (data.faturamentoData && data.faturamentoData.length > 0) {
        currentY = this.addChart(pdf, data.faturamentoData, 'Faturamento', currentY);
      }
      if (data.tipoServicoData && data.tipoServicoData.length > 0) {
        currentY = this.addChart(pdf, data.tipoServicoData, 'Tipos de Serviço', currentY);
      }
      if (data.timelineData && data.timelineData.length > 0) {
        currentY = this.addChart(pdf, data.timelineData, 'Ordens por Mês', currentY);
      }
    }
    
    if (includeList && data.orders && data.orders.length > 0) {
       const columns = [
         { key: 'id', label: 'ID' },
         { key: 'cliente', label: 'Cliente' },
         { key: 'status', label: 'Status' },
         { key: 'data', label: 'Data' }
       ];
       
      currentY = this.addTable(pdf, data.orders, columns, 'Lista de Ordens', currentY);
     }
    
         // Salvar PDF
     console.log('Salvando PDF do Dashboard...');
     pdf.save('dashboard_zaffari.pdf');
     console.log('PDF do Dashboard salvo com sucesso!');
    } catch (error) {
      console.error('Erro ao gerar PDF do Dashboard:', error);
      throw error;
    }
  }

     // Exportar relatório da empresa
   async exportCompanyReport(data) {
     console.log('Iniciando exportação do Relatório da Empresa PDF...', data);
     
     try {
       // Importação dinâmica
       const { jsPDF } = await import('jspdf');
       const pdf = new jsPDF('l', 'mm', 'a4');
    
    // Cabeçalho
    const startY = await this.addHeader(
      pdf, 
      'Relatório da Empresa', 
      `Empresa: 1728965891007x215886838679286700`
    );
    
    // KPIs
    const kpis = [
      { title: 'Total de Produtos', value: data.stats?.totalProdutos || '0' },
      { title: 'Total de Consultas', value: data.stats?.totalConsultas || '0' },
      { title: 'Dispositivos Ativos', value: data.stats?.totalDispositivos || '0' },
      { title: 'Filiais', value: data.stats?.totalFiliais || '0' }
    ];
    
         this.addKPIs(pdf, kpis, startY);
     
     // Produtos mais consultados
     if (data.produtosMaisConsultados && data.produtosMaisConsultados.length > 0) {
       const columns = [
         { key: 'codbar', label: 'Código' },
         { key: 'description', label: 'Descrição' },
         { key: 'num_consultas', label: 'Consultas' },
         { key: 'filial', label: 'Filial' }
       ];
       
       this.addTable(pdf, data.produtosMaisConsultados, columns, 'Produtos Mais Consultados', startY + 100);
     }
     
     // Estatísticas por filial
     if (data.estatisticasFiliais && data.estatisticasFiliais.length > 0) {
       const columns = [
         { key: 'filial', label: 'Filial' },
         { key: 'produtos', label: 'Produtos' },
         { key: 'consultas', label: 'Consultas' },
         { key: 'dispositivos', label: 'Dispositivos' }
       ];
       
       this.addTable(pdf, data.estatisticasFiliais, columns, 'Estatísticas por Filial', startY + 200);
     }
    
         // Salvar PDF
     console.log('Salvando PDF do Relatório da Empresa...');
     pdf.save('relatorio_empresa.pdf');
     console.log('PDF do Relatório da Empresa salvo com sucesso!');
    } catch (error) {
      console.error('Erro ao gerar PDF do Relatório da Empresa:', error);
      throw error;
    }
  }

     // Exportar lista de produtos
   async exportProductsReport(data) {
     try {
       // Importação dinâmica
       const { jsPDF } = await import('jspdf');
       const pdf = new jsPDF('l', 'mm', 'a4');
    
    // Cabeçalho
    const startY = await this.addHeader(
      pdf, 
      'Relatório de Produtos', 
      `Empresa: 1728965891007x215886838679286700`
    );
    
    // KPIs melhorados
    const kpis = [
      { title: 'Total de Produtos', value: data.totalProdutos || '0' },
      { title: 'Total de Consultas', value: data.totalConsultas || '0' },
      { title: 'Média de Consultas', value: data.mediaConsultas || '0' },
      { title: 'Produto Mais Consultado', value: data.produtoMaisConsultado?.num_consultas || '0' }
    ];
    
    let currentY = this.addKPIs(pdf, kpis, startY);
    
    // Análise por Filial
    if (data.products && data.products.length > 0) {
      const filialStats = this.generateFilialStats(data.products);
      currentY = this.addChart(pdf, filialStats, 'Consultas por Filial', currentY);
      
      // Análise por Dispositivo
      const dispositivoStats = this.generateDispositivoStats(data.products);
      currentY = this.addChart(pdf, dispositivoStats, 'Top 10 Dispositivos Mais Utilizados', currentY);
      
      // Produtos Mais Consultados
      const topProdutos = this.generateTopProdutos(data.products);
      currentY = this.addChart(pdf, topProdutos, 'Top 15 Produtos Mais Consultados', currentY);
      
      // Nova página para a tabela
      pdf.addPage();
      currentY = 20;
      
      // Tabela de produtos com mais detalhes
      const columns = [
        { key: 'codbar', label: 'Código' },
        { key: 'description', label: 'Descrição' },
        { key: 'apelido_dispositivo', label: 'Dispositivo' },
        { key: 'num_consultas', label: 'Consultas' },
        { key: 'filial', label: 'Filial' }
      ];
      
      this.addTable(pdf, data.products.slice(0, 50), columns, 'Lista Detalhada de Produtos (Top 50)', currentY);
      
      // Adicionar resumo estatístico na última página
      pdf.addPage();
      this.addProductSummary(pdf, data, 20);
    }
    
    // Salvar PDF
    console.log('Salvando PDF do Relatório de Produtos...');
    pdf.save(`relatorio_produtos_${new Date().toISOString().split('T')[0]}.pdf`);
    console.log('PDF do Relatório de Produtos salvo com sucesso!');
    } catch (error) {
      console.error('Erro ao gerar PDF do Relatório de Produtos:', error);
      throw error;
    }
  }

  // Métodos auxiliares para relatório de produtos
  generateFilialStats(products) {
    const filialMap = {};
    products.forEach(product => {
      const filial = product.filial || 'Não informado';
      const consultas = product.num_consultas || 0;
      filialMap[filial] = (filialMap[filial] || 0) + consultas;
    });
    
    return Object.entries(filialMap)
      .map(([filial, consultas]) => ({ label: `Filial ${filial}`, value: consultas }))
      .sort((a, b) => b.value - a.value);
  }
  
  generateDispositivoStats(products) {
    const dispositivoMap = {};
    products.forEach(product => {
      const dispositivo = product.apelido_dispositivo || 'Não informado';
      const consultas = product.num_consultas || 0;
      dispositivoMap[dispositivo] = (dispositivoMap[dispositivo] || 0) + consultas;
    });
    
    return Object.entries(dispositivoMap)
      .map(([dispositivo, consultas]) => ({ label: dispositivo, value: consultas }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 10);
  }
  
  generateTopProdutos(products) {
    return products
      .filter(product => product.num_consultas > 0)
      .sort((a, b) => (b.num_consultas || 0) - (a.num_consultas || 0))
      .slice(0, 15)
      .map(product => ({
        label: `${product.description?.substring(0, 40) || 'Sem descrição'}...`,
        value: product.num_consultas || 0
      }));
  }
  
  addProductSummary(pdf, data, startY) {
    const { margin } = this.getLayout(pdf);
    let currentY = startY;
    
    // Título
    pdf.setFontSize(18);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(51, 65, 85);
    pdf.text('Resumo Estatístico', margin.left, currentY);
    currentY += 20;
    
    // Estatísticas detalhadas
    const stats = [
      { label: 'Total de Produtos Analisados', value: data.totalProdutos || 0 },
      { label: 'Total de Consultas Registradas', value: data.totalConsultas || 0 },
      { label: 'Média de Consultas por Produto', value: data.mediaConsultas || '0.0' },
      { label: 'Produto com Mais Consultas', value: data.produtoMaisConsultado?.description?.substring(0, 50) || 'N/A' },
      { label: 'Número de Consultas do Top Produto', value: data.produtoMaisConsultado?.num_consultas || 0 }
    ];
    
    pdf.setFontSize(12);
    pdf.setFont('helvetica', 'normal');
    
    stats.forEach(stat => {
      pdf.setTextColor(100, 116, 139);
      pdf.text(String(stat.label) + ':', margin.left, currentY);
      pdf.setTextColor(51, 65, 85);
      pdf.setFont('helvetica', 'bold');
      pdf.text(String(stat.value), margin.left + 120, currentY);
      pdf.setFont('helvetica', 'normal');
      currentY += 12;
    });
    
    // Análise adicional
    currentY += 10;
    pdf.setFontSize(14);
    pdf.setFont('helvetica', 'bold');
    pdf.setTextColor(51, 65, 85);
    pdf.text('Análise de Distribuição', margin.left, currentY);
    currentY += 15;
    
    if (data.products && data.products.length > 0) {
      const produtosComConsulta = data.products.filter(p => (p.num_consultas || 0) > 0).length;
      const produtosSemConsulta = data.products.length - produtosComConsulta;
      const percentualAtivos = ((produtosComConsulta / data.products.length) * 100).toFixed(1);
      
      pdf.setFontSize(11);
      pdf.setFont('helvetica', 'normal');
      
      const analysisData = [
        { label: 'Produtos com Consultas', value: `${produtosComConsulta} (${percentualAtivos}%)` },
        { label: 'Produtos sem Consultas', value: `${produtosSemConsulta} (${(100 - parseFloat(percentualAtivos)).toFixed(1)}%)` },
        { label: 'Taxa de Utilização', value: `${percentualAtivos}%` }
      ];
      
      analysisData.forEach(item => {
        pdf.setTextColor(100, 116, 139);
        pdf.text(String(item.label) + ':', margin.left + 10, currentY);
        pdf.setTextColor(51, 65, 85);
        pdf.setFont('helvetica', 'bold');
        pdf.text(String(item.value), margin.left + 120, currentY);
        pdf.setFont('helvetica', 'normal');
        currentY += 10;
      });
    }
    
    // Rodapé com data de geração
    currentY += 20;
    pdf.setFontSize(9);
    pdf.setTextColor(100, 116, 139);
    pdf.text(`Relatório gerado em: ${new Date().toLocaleString('pt-BR')}`, margin.left, currentY);
    pdf.text('Sistema de Gestão - Relatório de Produtos', margin.left, currentY + 8);
    
    return currentY;
  }

     // Exportar estatísticas
   async exportStatisticsReport(data) {
     console.log('Iniciando exportação das Estatísticas PDF...', data);
     
     try {
       // Importação dinâmica
       const { jsPDF } = await import('jspdf');
       const pdf = new jsPDF('l', 'mm', 'a4');
    
    // Cabeçalho
    const startY = await this.addHeader(
      pdf, 
      'Estatísticas Detalhadas', 
      `Empresa: 1728965891007x215886838679286700`
    );
    
    // KPIs principais
    const kpis = [
      { title: 'Total de Produtos', value: data.estatisticasGerais?.totalProdutos || '0' },
      { title: 'Total de Consultas', value: data.estatisticasGerais?.totalConsultas || '0' },
      { title: 'Dispositivos Ativos', value: data.estatisticasGerais?.totalDispositivos || '0' },
      { title: 'Filiais', value: data.estatisticasGerais?.totalFiliais || '0' }
    ];
    
         this.addKPIs(pdf, kpis, startY);
     
     // Consultas por filial
     if (data.consultasPorFilial && data.consultasPorFilial.length > 0) {
       this.addChart(pdf, data.consultasPorFilial, 'Consultas por Filial', startY + 100);
     }
     
     // Produtos por categoria
     if (data.produtosPorCategoria && data.produtosPorCategoria.length > 0) {
       this.addChart(pdf, data.produtosPorCategoria, 'Produtos por Categoria', startY + 150);
     }
     
     // Top filiais
     if (data.estatisticasFiliais && data.estatisticasFiliais.length > 0) {
       const columns = [
         { key: 'filial', label: 'Filial' },
         { key: 'produtos', label: 'Produtos' },
         { key: 'consultas', label: 'Consultas' },
         { key: 'dispositivos', label: 'Dispositivos' }
       ];
       
       this.addTable(pdf, data.estatisticasFiliais.slice(0, 10), columns, 'Top Filiais', startY + 200);
     }
    
         // Salvar PDF
     console.log('Salvando PDF das Estatísticas...');
     pdf.save('estatisticas_detalhadas.pdf');
     console.log('PDF das Estatísticas salvo com sucesso!');
    } catch (error) {
      console.error('Erro ao gerar PDF das Estatísticas:', error);
      throw error;
    }
  }
}

const pdfExportService = new PdfExportService();
export default pdfExportService;
